export interface ICode {
  is_candidate?: any;
  is_postulate?: any;
  mail?: any;
  candidate_id?: any;
  status_code?: any;
  message?: any;
}

export const defaultValue: Readonly<ICode> = {};

export const initialValuesCode: ICode = {
  is_candidate: null,
  is_postulate: null,
  mail: null,
  candidate_id: null,
  status_code: null,
  message: null,
};
